import { createContext, useContext } from 'react';

const EventNotificationsEntityIdContext = createContext<undefined | number>(undefined);

export function EventNotificationsEntityIdProvider(props: {
    children: React.ReactNode;
    entityId: number | undefined;
}) {
    return (
        <EventNotificationsEntityIdContext.Provider value={props.entityId}>
            {props.children}
        </EventNotificationsEntityIdContext.Provider>
    );
}

export function useEventNotificationsEntityId(): number | undefined {
    return useContext(EventNotificationsEntityIdContext);
}
